<template>
  <div class="ls-share-main">
    <LsIcon :size-override="90" type="gift" :color="platform.accentColor" />
    <h1 class="ls-share-main--cta">{{ platform.cta }}</h1>
    <p class="ls-share-main--copy">{{ platform.description }}</p>
    <div class="ls-share-main--button-container">
      <LsButton
        :track-id="`ls_share_main-${platform.platformName}`"
        :icon="platform.buttonIcon"
        :text="platform.button_text"
        :bg-color="platform.accentColor"
        class="ls-share-main--button"
        test-id="button"
        @click="shareViaPlatform"
      />
      <div v-if="platform.share_completed_at" class="ls_share_main--is-shared">
        <LsIcon type="checkmark" size="sm" />
        <p class="ls_share_main--shared-text">Shared</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SHARE__TRACK_COMPONENT_VIEWED,
  SHARE__SHARE_VIA_PLATFORM,
  SHARE__PRIMARY_PLATFORM,
  SHARE__WIDGET_PLATFORM,
  SHARE__PLATFORMS,
} from '@/store/types';
import { mapActions, mapGetters } from 'vuex';
import { LsButton, LsIcon } from '@/components/common';
import { lsModalService, lsRouterHelpers } from 'ls-vue-common';
import { EmailModal, NextDoorModal } from '@/modals';

export default {
  name: 'LsShareMain',
  components: {
    LsButton,
    LsIcon,
  },
  data() {
    return {
      name: lsRouterHelpers.getName(this.$route),
    };
  },
  computed: {
    ...mapGetters([SHARE__PRIMARY_PLATFORM, SHARE__PLATFORMS, SHARE__WIDGET_PLATFORM]),
    platform() {
      if (this.name === 'share') {
        return this[SHARE__PRIMARY_PLATFORM];
      }

      if (this.name === 'onboardingWelcomeShare') {
        return this[SHARE__PLATFORMS].nextdoor;
      }

      return this[SHARE__WIDGET_PLATFORM];
    },
  },
  mounted() {
    if (this.name === 'onboardingWelcomeShare') {
      return;
    }

    this[SHARE__TRACK_COMPONENT_VIEWED]({
      componentName: this.name === 'share' ? 'ShareView' : 'ShareWidget',
    });
  },
  methods: {
    ...mapActions([SHARE__TRACK_COMPONENT_VIEWED, SHARE__SHARE_VIA_PLATFORM]),
    shareViaPlatform() {
      const { platformName } = this.platform;

      if (platformName === 'nextdoor' || platformName === 'email') {
        lsModalService.open({
          parent: this,
          component: platformName === 'nextdoor' ? NextDoorModal : EmailModal,
          width: 600,
        });
      } else {
        this[SHARE__SHARE_VIA_PLATFORM]({ platform: this.platform });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-share-main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  padding: 0 10px;
}

.ls-share-main--cta {
  font-weight: bold;
  color: $gray-primary;
  margin: 30px 0 10px 0;
  text-align: center;
  width: 100%;
}

.ls-share-main--copy {
  text-align: center;
  width: 100%;
}

.ls-share-main--button-container {
  margin-top: 25px;
  width: 100%;
}

.ls-share-main--button {
  height: 44px;
  min-width: 250px;
}

.ls_share_main--is-shared {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

.ls_share_main--shared-text {
  font-weight: bold;
  padding-left: 6px;
  transform: translateY(-1px);
}

@media (min-width: $desktop) {
  .ls-share-main {
    border: 1px solid $special-navbar-overlay;
  }

  .ls-share-main--button-container {
    width: inherit;
  }
}

.themed-app {
  .ls-share-main--cta {
    color: $theme-color-gray-darker;
  }

  @media (min-width: $desktop) {
    .ls-share-main {
      border-color: $theme-color-gray;
    }
  }
}
</style>
